import React from "react";

export const NumberCount = ({
  count,
  size = "default",
  showZero = false,
}: {
  count: number;
  size?: "default" | "sm";
  /// Draw a zero, muted, where the empty count is the point.
  showZero?: boolean;
}) => {
  if (count === 0 && !showZero) return null;
  return (
    <span
      className={`shrink-0 inline-flex items-center justify-center rounded-full ${
        count === 0
          ? "bg-bg-hover text-fg-muted"
          : "bg-accent-15 text-accent-regular"
      } select-none cursor-default ${
        size === "sm" ? "px-1.5 py-px text-[10px]" : "px-1.5 py-px text-xs"
      }`}
    >
      {count}
    </span>
  );
};
